/**
 * Client-side SAMPLE data for the PESO Panglao staff dashboard demo.
 *
 * Activated by visiting the dashboard with ?demo=1. When on, PesoDashboard reads these
 * objects INSTEAD of calling the API — so the demo NEVER touches the database or the live
 * job marketplace (the earlier mistake was seeding real `open` jobs into production).
 * The shapes here mirror exactly what /api/peso/analytics, /matches, /registrations and
 * /reports/summary return.
 */

// ---- 14 sample jobseekers (single source of truth for the seeker-facing views) ----
const S = [
  { id: 'demo-s1', name: 'Carlo Mercado', town: 'Tawala', sex: 'male', age: 34, verified: true, fourps: true, skills: ['Housekeeping', 'Room Attendant'], best: { title: 'Hotel Housekeeper', employer: 'Alona Beach Resort', score: 9 }, others: [] },
  { id: 'demo-s2', name: 'Maria Salazar', town: 'Doljo', sex: 'female', age: 22, verified: false, youth: true, skills: ['Front Desk', 'Customer Service'], best: { title: 'Front Desk Officer', employer: 'Alona Beach Resort', score: 12 }, others: [] },
  { id: 'demo-s3', name: 'Jose Flores', town: 'Lourdes', sex: 'male', age: 41, verified: true, skills: ['Cooking', 'Food Preparation'], best: { title: 'Restaurant Cook', employer: 'Bohol Bee Farm Restaurant', score: 8 }, others: [] },
  { id: 'demo-s4', name: 'Ana Ramos', town: 'Tawala', sex: 'female', age: 28, verified: true, skills: ['Diving Instructor', 'Watersports'], best: { title: 'Dive Instructor', employer: 'Doljo Beach Dive Center', score: 9 }, others: [] },
  { id: 'demo-s5', name: 'Liza Lim', town: 'Poblacion', sex: 'female', age: 35, verified: false, skills: ['Tour Guiding', 'Local Tours'], best: { title: 'Licensed Tour Guide', employer: 'Panglao Island Day Tours', score: 10 }, others: [] },
  { id: 'demo-s6', name: 'Mark Garcia', town: 'Bolod', sex: 'male', age: 24, verified: true, youth: true, skills: ['Waiter', 'Food Service'], best: { title: 'Waiter / Waitress', employer: 'Bohol Bee Farm Restaurant', score: 7 }, others: [] },
  { id: 'demo-s7', name: 'Grace Aquino', town: 'Libaong', sex: 'female', age: 30, verified: true, fourps: true, skills: ['Housekeeping', 'Room Attendant'], best: { title: 'Hotel Housekeeper', employer: 'Alona Beach Resort', score: 6 }, others: [] },
  { id: 'demo-s8', name: 'Rey Degamo', town: 'Libaong', sex: 'male', age: 27, verified: false, skills: ['Bartending', 'Barista'], best: null, others: [] },
  { id: 'demo-s9', name: 'Edgar Bolanio', town: 'Tawala', sex: 'male', age: 45, verified: true, skills: ['Driving', 'Van Driver'], best: null, others: [] },
  { id: 'demo-s10', name: 'Divine Amora', town: 'Danao', sex: 'female', age: 33, verified: false, pwd: true, skills: ['Accounting', 'Bookkeeping'], best: null, others: [] },
  { id: 'demo-s11', name: 'Rosa Villanueva', town: 'Doljo', sex: 'female', age: 38, verified: true, skills: ['Cooking', 'Food Preparation'], best: { title: 'Restaurant Cook', employer: 'Bohol Bee Farm Restaurant', score: 6 }, others: [] },
  { id: 'demo-s12', name: 'Allan Oppus', town: 'Lourdes', sex: 'male', age: 21, verified: false, youth: true, ofw: true, skills: ['Sales', 'Cashier'], best: null, others: [] },
  { id: 'demo-s13', name: 'Shiela Reyes', town: 'Poblacion', sex: 'female', age: 26, verified: true, former_ofw: true, skills: ['Front Desk', 'Customer Service'], best: { title: 'Front Desk Officer', employer: 'Alona Beach Resort', score: 8 }, others: [] },
  { id: 'demo-s14', name: 'Michael Lumayag', town: 'Libaong', sex: 'male', age: 52, verified: false, pwd: true, skills: ['Carpentry', 'Construction'], best: null, others: [] },
];

// ---- 6 currently-open vacancies + 7 employers ----
const VAC = [
  { title: 'Waiter / Waitress', employer: 'Bohol Bee Farm Restaurant', positions: 4 },
  { title: 'Hotel Housekeeper', employer: 'Alona Beach Resort', positions: 3 },
  { title: 'Licensed Tour Guide', employer: 'Panglao Island Day Tours', positions: 3 },
  { title: 'Front Desk Officer', employer: 'Alona Beach Resort', positions: 2 },
  { title: 'Restaurant Cook', employer: 'Bohol Bee Farm Restaurant', positions: 2 },
  { title: 'Dive Instructor', employer: 'Doljo Beach Dive Center', positions: 1 },
];
const EMP = [
  { id: 'demo-e1', name: 'Alona Beach Resort', town: 'Tawala', phone: '0917 555 0101', state: 'approved', drafts: 0 },
  { id: 'demo-e2', name: 'Bohol Bee Farm Restaurant', town: 'Doljo', phone: '0917 555 0102', state: 'approved', drafts: 0 },
  { id: 'demo-e3', name: 'Panglao Island Day Tours', town: 'Tawala', phone: '0917 555 0103', state: 'approved', drafts: 0 },
  { id: 'demo-e4', name: 'Doljo Beach Dive Center', town: 'Doljo', phone: '0917 555 0104', state: 'renewal', drafts: 0 },
  { id: 'demo-e5', name: 'Tangnan Hardware & Construction Supply', town: 'Tangnan', phone: '0917 555 0105', state: 'pending', drafts: 2 },
  { id: 'demo-e6', name: 'Poblacion Mini Mart & Grocery', town: 'Poblacion', phone: '0917 555 0106', state: 'pending', drafts: 1 },
  { id: 'demo-e7', name: 'Libaong Seaside Grill', town: 'Libaong', phone: '0917 555 0107', state: 'pending', drafts: 2 },
];

// ---- derive coherent aggregates so every tab agrees ----
const count = (arr, fn) => arr.reduce((n, x) => n + (fn(x) ? 1 : 0), 0);
const solicited = VAC.reduce((n, v) => n + v.positions, 0);   // 15
const registered = S.length;                                   // 14
const referred = 10;
const placed = 4;
const verifiedN = count(S, (s) => s.verified);
const tally = (pairs) => {
  const m = {};
  pairs.forEach((k) => { if (k) m[k] = (m[k] || 0) + 1; });
  return m;
};
const townMap = tally(S.map((s) => s.town));
const skillMap = {};
S.forEach((s) => (s.skills || []).forEach((k) => { skillMap[k] = (skillMap[k] || 0) + 1; }));
const titleMap = {}; const empMap = {};
VAC.forEach((v) => { titleMap[v.title] = (titleMap[v.title] || 0) + v.positions; empMap[v.employer] = (empMap[v.employer] || 0) + v.positions; });
const rankObj = (m, kk, vk) => Object.entries(m).map(([k, v]) => ({ [kk]: k, [vk]: v })).sort((a, b) => b[vk] - a[vk]);
const band = (a) => (a <= 24 ? '15-24' : a <= 34 ? '25-34' : a <= 44 ? '35-44' : a <= 54 ? '45-54' : a <= 64 ? '55-64' : '65+');
const bandMap = tally(S.map((s) => band(s.age)));
const pct = (n, d) => (d ? Math.round((n / d) * 1000) / 10 : 0);

// ---- Organic / "Platform" Panglao layer (the broader Bohol Trabaho user base located in
// Panglao). Shown on the dashboard as a partnership benefit, ALWAYS labeled distinctly from
// PESO registrations, and NEVER part of the DOLE/SPRS reports. Demo-only sample numbers. ----
const PLATFORM = { seekers: 184, employers: 23, open_vacancies: 30 };
const townsPlatform = [
  { town: 'Tawala', count: 42 }, { town: 'Poblacion', count: 31 }, { town: 'Doljo', count: 24 },
  { town: 'Libaong', count: 19 }, { town: 'Danao', count: 16 }, { town: 'Lourdes', count: 14 },
  { town: 'Bolod', count: 12 }, { town: 'Tangnan', count: 11 }, { town: 'Looc', count: 9 }, { town: 'Bil-isan', count: 6 },
];
const inDemandPlatform = [
  { title: 'Hotel Housekeeper', vacancies: 9 }, { title: 'Waiter / Waitress', vacancies: 8 },
  { title: 'Restaurant Cook', vacancies: 6 }, { title: 'Front Desk Officer', vacancies: 5 },
  { title: 'Spa Therapist', vacancies: 4 }, { title: 'Bartender', vacancies: 3 }, { title: 'Security Guard', vacancies: 3 },
];
const applicantSupplyPlatform = [
  { name: 'Housekeeping', count: 46 }, { name: 'Customer Service', count: 38 }, { name: 'Cooking', count: 31 },
  { name: 'Food Service', count: 27 }, { name: 'Front Desk', count: 22 }, { name: 'Driving', count: 18 },
  { name: 'Bartending', count: 14 }, { name: 'Tour Guiding', count: 12 },
];
const topEmployersPlatform = [
  { name: 'Henann Resort Alona Beach', vacancies: 12 }, { name: 'South Palms Resort Panglao', vacancies: 9 },
  { name: 'BE Grand Resort', vacancies: 7 }, { name: 'Amorita Resort', vacancies: 5 },
  { name: 'Panglao Regents Park', vacancies: 3 }, { name: 'The Bellevue Resort', vacancies: 2 },
];
const trendPlatform = { '2026-01': 18, '2026-02': 22, '2026-03': 27, '2026-04': 31, '2026-05': 38, '2026-06': 48 };

const analytics = {
  office: { slug: 'panglao', name: 'PESO Panglao' },
  totals: { seekers: registered, employers: EMP.length, registrations: registered + EMP.length },
  seekers: { total: registered, verified: verifiedN, pending: registered - verifiedN },
  employers: {
    total: EMP.length,
    approved: count(EMP, (e) => e.state === 'approved' || e.state === 'renewal'),
    pending: count(EMP, (e) => e.state === 'pending'),
    renewal_due: count(EMP, (e) => e.state === 'renewal'),
  },
  vacancies: { open: VAC.length, pending_drafts: EMP.reduce((n, e) => n + e.drafts, 0) },
  // Organic/platform Panglao layer (partnership data — labeled, never in DOLE reports)
  platform: PLATFORM,
  towns_platform: townsPlatform,
  towns: rankObj(townMap, 'town', 'count'),
  trend: [
    { month: '2026-01', seekers: 1, employers: 1 },
    { month: '2026-02', seekers: 2, employers: 1 },
    { month: '2026-03', seekers: 2, employers: 1 },
    { month: '2026-04', seekers: 3, employers: 2 },
    { month: '2026-05', seekers: 3, employers: 1 },
    { month: '2026-06', seekers: 3, employers: 1 },
  ].map((t) => ({ ...t, seekers_platform: trendPlatform[t.month] || 0 })),
  renewal_cutoff: '2026-03-01T00:00:00+00:00',
  insights: {
    funnel: { solicited, registered, referred, placed },
    rates: { placement_referred: pct(placed, referred), placement_registered: pct(placed, registered), fill_rate: pct(placed, solicited) },
    sex: { male: count(S, (s) => s.sex === 'male'), female: count(S, (s) => s.sex === 'female'), unknown: 0 },
    age_bands: ['15-24', '25-34', '35-44', '45-54', '55-64', '65+'].map((b) => ({ band: b, count: bandMap[b] || 0 })),
    special_groups: [
      { key: 'ofw', label: 'OFW', count: count(S, (s) => s.ofw) },
      { key: 'former_ofw', label: 'Returning OFW', count: count(S, (s) => s.former_ofw) },
      { key: 'fourps', label: '4Ps', count: count(S, (s) => s.fourps) },
      { key: 'pwd', label: 'PWD', count: count(S, (s) => s.pwd) },
      { key: 'youth', label: 'Youth (15-24)', count: count(S, (s) => s.youth) },
      { key: 'senior', label: 'Senior (60+)', count: count(S, (s) => s.age >= 60) },
    ],
    in_demand: rankObj(titleMap, 'title', 'vacancies'),
    in_demand_platform: inDemandPlatform,
    applicant_supply: rankObj(skillMap, 'name', 'count').slice(0, 8),
    applicant_supply_platform: applicantSupplyPlatform,
    top_employers: rankObj(empMap, 'name', 'vacancies'),
    top_employers_platform: topEmployersPlatform,
    coverage: { profiled: Object.keys(townMap).length, total: 10 },
  },
};

const matches = {
  open_vacancies: VAC.length,
  seekers: S.length,
  matched: count(S, (s) => s.best),
  // Mirrors the real /api/peso/matches shape: an evidence ledger per seeker and an AI
  // score on the 0-100 scale. The demo previously carried a flat `skills` array and
  // recall-scale scores, which render as "no evidence recorded" and collapse every row
  // to the lowest tier once the UI reads the real shape.
  matches: S.map((s) => ({
    seeker_id: s.id, name: s.name, verified: s.verified, town: s.town,
    status: s.best ? 'matched' : 'no_open_match',
    evidence: {
      skills: s.skills || [],
      other_skills: [],
      occupations: [],
      work_titles: [],
      education: '', education_field: '', years_of_experience: null, town: s.town,
      has_any_competence_record: (s.skills || []).length > 0,
      has_any_history_record: false,
      has_stated_interest: false,
    },
    best: s.best ? {
      ...s.best,
      score: Math.min(100, Math.round((s.best.score || 0) * 7)),
      reason: s.best.reason || `Recorded skills (${(s.skills || []).slice(0, 2).join(', ') || 'none'}) considered against this vacancy.`,
      reason_ceb: s.best.reason_ceb || '',
      reason_withheld: false,
      evidence_status: 'verified',
    } : null,
    others: s.others || [],
  })).sort((a, b) => (b.best?.score || -1) - (a.best?.score || -1)),
};

const registrations = {
  seekers: S.map((s) => ({ id: s.id, name: s.name, town: s.town, verified: s.verified, created_at: '2026-05-01' })),
  employers: EMP.map((e) => ({
    id: e.id, name: e.name, phone: e.phone, town: e.town,
    peso_approved: e.state === 'approved' || e.state === 'renewal',
    peso_approved_at: e.state === 'approved' ? '2026-05-10' : e.state === 'renewal' ? '2026-01-20' : null,
    renewal_due: e.state === 'renewal', verified: e.state !== 'pending',
    created_at: '2026-04-15', pending_drafts: e.drafts,
  })),
  pending_seekers: registered - verifiedN,
  renewal_cutoff: '2026-03-01T00:00:00+00:00',
};

const summary = {
  office: 'panglao', range: { start: null, end: null },
  registered: { total: registered, male: count(S, (s) => s.sex === 'male'), female: count(S, (s) => s.sex === 'female'), verified: verifiedN },
  vacancies: { postings: VAC.length, positions: solicited },
  referred,
  placed: { applications: placed, seekers: placed },
};

const events = [
  {
    id: 'demo-ev-1', code: 'sra-belmont-jul2026', name: 'SRA Belmont Hotel — Panglao',
    event_type: 'sra', venue: 'Belmont Hotel Bohol', start_date: '2026-07-15', end_date: '2026-07-15',
    status: 'active', seeker_count: 42, employer_count: 3,
    seeker_url: 'https://www.boholtrabaho.com/peso/panglao/seeker?event=sra-belmont-jul2026',
    employer_url: 'https://www.boholtrabaho.com/peso/panglao/employer?event=sra-belmont-jul2026',
  },
  {
    id: 'demo-ev-2', code: 'jobfair-panglao-aug2026', name: 'Panglao Tourism Job Fair 2026',
    event_type: 'job_fair', venue: 'Panglao Municipal Gym', start_date: '2026-08-05', end_date: '2026-08-06',
    status: 'active', seeker_count: 118, employer_count: 12,
    seeker_url: 'https://www.boholtrabaho.com/peso/panglao/seeker?event=jobfair-panglao-aug2026',
    employer_url: 'https://www.boholtrabaho.com/peso/panglao/employer?event=jobfair-panglao-aug2026',
  },
];

export const PESO_DEMO = { analytics, matches, registrations, summary, events };

// A complete sample NSRP profile for demo-mode "Print NSRP" (rendered by the backend
// POST /api/peso/nsrp/preview from this payload — no DB read/write). The clicked seeker's
// name + town are merged in at print time so the form shows that jobseeker.
export const PESO_DEMO_NSRP = {
  name: 'Carlo Mercado',
  email: 'demo.seeker@panglao-demo.test',
  phone: '09171234567',
  town: 'Tawala',
  date_of_birth: '1991-04-12',
  education_level: 'high_school',
  years_of_experience: '3_to_5',
  skills: ['Housekeeping', 'Room Attendant'],
  nsrp_data: {
    personal: {
      surname: 'Mercado', first_name: 'Carlo', middle_name: 'D.', suffix: '',
      sex: 'male', civil_status: 'married',
      place_of_birth: 'Tagbilaran City, Bohol', citizenship: 'Filipino',
      height: '168 cm', weight: '64 kg', landline: '', mobile_secondary: '',
      address_house: 'Purok 3', barangay: 'Tawala', municipality: 'Panglao', province: 'Bohol',
      perm_same: true, disability: [], disability_other: '',
    },
    employment: {
      status: 'unemployed', separation_reasons: ['resigned'],
      job_search_months: '3', willing_immediately: 'yes', willing_when: '',
      fourps: 'yes', fourps_household_id: '04-12-3456', ofw: 'no', former_ofw: 'no',
    },
    preferences: {
      occupations: ['Room Attendant', 'Housekeeper', 'Hotel Staff'],
      industries: ['Tourism', 'Hospitality'],
      local: ['Panglao, Bohol', 'Tagbilaran City'], overseas: [],
      salary_expectation: '12,000 - 14,000',
    },
    currently_in_school: 'no',
    highest_education: 'hs_grad',
    education_rows: [{ school: 'Panglao National High School', course: '', year_graduated: '2009', year_last: '', awards: '' }],
    currently_in_training: 'no',
    training_rows: [{ course: 'Housekeeping NC II', institution: 'TESDA Bohol', hours: '356', cert: 'NC II', completed: 'yes' }],
    eligibility: { civil_service: '', prc_license: '', prc_valid_until: '', eligibility_date: '' },
    language: { certs: [], cert_other: '', validity: '' },
    dialects: { list: ['Tagalog', 'Others'], other: 'Cebuano (Binisaya)' },
    work_experience: [{ company: 'Henann Resort Alona Beach', city: 'Panglao, Bohol', position: 'Room Attendant', months: '28', appointment_status: 'contractual' }],
    skills_21: ['Work Ethics', 'Team Work', 'Multitasking', 'Stress Tolerance', 'Self Motivation'],
    other_skills: [],
  },
};
